import { render } from "./GameFi.vue?vue&type=template&id=0ac6f4b2&scoped=true"
const script = {}

import "./GameFi.vue?vue&type=style&index=0&id=0ac6f4b2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac6f4b2"]])

export default __exports__